var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.displayMap.showSignIn)?_c('signIn',{on:{"forgotPassword":function (data) {
        _vm.user = data;
      },"confirmSignUp":function (data) {
        _vm.user = data;
      },"confirmsignupcustomflow":function (data) {
        _vm.user = data;
      }}}):_vm._e(),(_vm.displayMap.showForgotPassword)?_c('forgotPassword'):_vm._e(),(_vm.displayMap.requireNewPassword)?_c('requireNewPassword',{attrs:{"user":_vm.user,"rules":"password"}}):_vm._e(),(_vm.displayMap.confirmSignUp)?_c('confirmSignUp',{attrs:{"user":_vm.user}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }